<template>
  <div>
    <input-validate title="Name" type="text" name="pnname" v-model="pnname" placeholder="Enter your name"
                    v-validate="'required|pnname'" data-vv-value-path="innerValue" data-vv-validate-on="blur"
                    :error="errors.first('pnname')">
    </input-validate>
    <input-validate title="Account" type="text" name="account" v-model="account" placeholder="Enter your account"
                    v-validate="'required|account'" data-vv-value-path="innerValue" data-vv-validate-on="blur"
                    :error="errors.first('account')">
    </input-validate>
    <div v-if="backup_upi.length > 0">
      <md-field-item title="UPI" :content="upi" @click="showSelector" arrow solid/>
    </div>
    <md-selector v-model="isSelectorupiShow" default-value="2" :data="backup_upi" max-height="320px" title="UPI list"
                 large-radius @choose="onSelectorChoose"></md-selector>
    <a ref="myLink" :href="linkurl"></a>
    <md-button class="mt-3" type="primary" :loading="link_loading" :disabled="link_loading" @click="submit_ct"
               v-if="viewOperate === 'edit'">Save
    </md-button>
    <md-button class="mt-3" type="primary" :loading="link_loading" :disabled="link_loading" @click="submit_ct" v-else>{{
        btn_name
      }}
    </md-button>
    <md-captcha ref="captcha" v-model="show" :count="120" count-active-text="{$1} ReSend" count-normal-text="ReSend"
                :title="title" :maxlength="optlength" :system="system" :mask="mask" :appendTo="appendTo"
                @submit="monitorflowthree_submit_code" @show="onShow" @hide="onHide" @send="onSend">
      {{ content }}
    </md-captcha>
  </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import {Validator} from "vee-validate";
import inputValidate from "@/components/input-validate";
import {Dialog} from 'mand-mobile'
import {
  editcollectiontool,
  monitorflowone,
  monitorflowtwo,
  monitorflowthree,
  monitorflowcheck,
  monitorflowtwo_getpreloginresult
} from '@/request/api'

Validator.extend("account", {
  getMessage: field => `${field} value do not meet right format`,
  validate: value => /^\d{10}$/.test(value)
});
// Validator.extend("upiid", {
//     getMessage: field => `${field} value do not meet right format`,
//     validate: value => /^[\s\S]*@[\s\S]*$/.test(value)
// });
Validator.extend("pnname", {
  getMessage: field => `${field} value do not meet right format`,
  validate: value => {
    return true
  }
});


export default {
  name: 'otplogin',
  components: {
    topback,
    iconimg,
    inputValidate
  },
  props: {
    type: {
      type: String,
      default: ""
    },
    ct: {
      type: Object,
      default: null
    },
    operate: {
      type: String,
      default: "add"
    }
  },
  data() {
    return {
      edit: false,
      account: "",
      pnname: "",
      optlength: 5,
      link_loading: false,
      monitor_pk: "",
      monitor_check_interval: "",
      check_send_otp_result_interval: "",
      check_count: 0,
      isSelectorupiShow: false,
      upi: "select available upi",
      backup_upi: [],
      btn_name: "Link Kyc",
      ct_id: "",
      ct_type: "",
      linkurl: "",
      viewOperate: "add",

      // otp
      show: false,
      appendTo: document.body,
      title: 'Enter OTP',
      content: 'OTP has been sent',
      mask: false,
      system: true,
      otpinterval: "",
      otp_send_times: 0,
      send_otp: false,
    }
  },
  created() {
    console.log(this.ct, "页面加载 ");
    this.viewOperate = this.operate;
    if (this.ct) {
      this.account = this.ct.account;
      this.pnname = this.ct.pnname;
      this.backup_upi = this.format_backup_upi(this.ct.backup_upi);
      this.upi = this.ct.upi || "select available upi";
      this.edit = true;
      this.ct_id = this.ct.id;
      console.log(this.ct, "页面加载 ");
      if (this.ct.state === "idle") {
        this.edit = true;
        this.viewOperate = "edit";
      }
    } else {
      this.account = "";
      this.pnname = "";
      this.edit = false;
    }
  },
  watch: {
    operate(newVal) {
      this.viewOperate = newVal;
    }
  },
  methods: {
    format_backup_upi(backup_upi) {
      let backup_upi_kv = []
      if (backup_upi) {
        backup_upi.forEach(upi => {
          backup_upi_kv.push({
            value: upi,
            text: upi
          })
        });
      }
      return backup_upi_kv
    },
    submit_ct() {
      let that = this;
      if (this.type === '') {
        this.$toast.failed("please select the kyc partner");
        return false;
      }
      this.link_loading = true;
      const success = this.$validator.validateAll().then(res => {
        if (res) {
          if (this.viewOperate === "edit") {
            let formdata = {id: this.ct_id}
            if (this.upi === "select available upi") {
              this.$toast.failed("select available upi");
              return;
            }
            formdata.upi = this.upi;
            formdata.pnname = this.pnname;
            editcollectiontool(formdata).then(res => {
              that.link_loading = false;
              if (res.code === 200) {
                Dialog.alert({
                  title: 'Success',
                  content: 'Please wait patiently for 1~3 minutes, kyc partner will verify the authorization',
                  confirmText: 'Ok',
                  onConfirm: () => {
                    that.$router.push("/kycpartner");
                  }
                })
              } else {
                that.$toast.failed(res.errmsg);
              }
            }).catch(error => {
              console.log(error);
              that.$toast.failed("Network Error!");
              that.link_loading = false;
            })
          } else {
            monitorflowone({
              ct_type: that.type,
              account: that.account,
              pnname: that.pnname
            }).then(res => {
              that.link_loading = false;
              console.log(res);
              if (res.code === 200) {
                that.monitor_pk = res.data.pk;
                if (that.monitor_pk === "" || that.monitor_pk === null || that.monitor_pk === undefined) {
                  that.$toast.failed("please try again");
                  return;
                }
                that.monitor_check(true, true);
              } else if (res.code === 400 && res.errmsg === "noneedlogin") {
                console.log("noneedlogin");
                that.$toast.loading("sync kyc...", 10000);
                that.monitor_check(true, false);
                that.viewOperate = "edit";
                that.edit = true;
                //that.$router.push("/editkycpartner/edit/"+ that.ct_id);
                //editkycpartner/edit/15093
              } else {
                that.$toast.failed(res.errmsg);
              }
            }).catch(error => {
              console.log(error);
              that.$toast.failed("Network Error!");
              that.link_loading = false;
            })
          }
        } else {
          that.link_loading = false;
          return
        }
      })
    },
    client_login() {
      this.monitorflowtwo_send_otp();
    },
    monitor_check(first, send_otp) {
      console.log("monitor_check", first, send_otp, this.check_count);
      if (this.monitor_pk === "" || this.monitor_pk === null || this.monitor_pk === undefined) {
        this.$toast.failed("please try again");
        return;
      }
      if (!this.send_otp) {
        this.$toast.hide();
        this.$toast.loading("Please wait check kyc...", 6000);
      }
      monitorflowcheck({
        ct_type: this.type,
        account: this.account
      }).then(res => {
        if (res.code === 200) {
          this.ct_type = res.data.ct_type;
          this.check_count += 1;
          let state = res.data.state;
          if (state === "idle") {
            this.check_success_after(res.data);
            setTimeout(() => {
              this.$router.push("/kycpartner");
            }, 2000);
            return;
          }
          if (state === "loginerror") {
            this.check_fail_after("login failed");
            return;
          }
        }
        if (first && send_otp) {
          this.client_login();
        }
        if (first) {
          let that = this;
          this.monitor_check_interval = setInterval(() => {
            that.monitor_check(false, false)
          }, 5000);
        }
      })
    },
    check_success_after(data) {
      console.log("check_success_after: ", data);
      this.show = false;
      this.$toast.hide();
      this.$toast.succeed("key suuccess");
      this.check_count = 0;
      this.backup_upi = this.format_backup_upi(data.backup_upi);
      this.viewOperate = "edit";
      this.ct_id = data.id;
      window.clearInterval(this.monitor_check_interval);
    },
    check_fail_after(msg) {
      this.check_count = 0;
      this.$toast.hide();
      this.$toast.failed(msg);
      window.clearInterval(this.monitor_check_interval);
    },
    showSelector() {
      this.isSelectorupiShow = true
    },
    onSelectorChoose({text}) {
      this.upi = text
    },
    // otp 相关
    monitorflowtwo_send_otp() {
      this.send_otp = true;
      this.$toast.hide();
      this.$toast.loading("send otp...", 30000);
      monitorflowtwo({
        pk: this.monitor_pk
      }).then(res => {
        if (res.code === 200) {
          // 启动查询 预登录 结果 查询
          this.check_send_otp_result(true);
        } else {
          if (res.errmsg === "task is registered") {
            this.check_send_otp_result(true);
          } else {
            this.$toast.failed(res.errmsg);
          }
        }
      }).catch(error => {
        console.log("monitorflowtwo: ", error);
      })
    },
    check_send_otp_result(first) {
      let that = this;
      console.log("检查预登陆结果：", first);
      monitorflowtwo_getpreloginresult({
        pk: that.monitor_pk
      }).then(res => {
        if (res.code === 200) {
          console.log("发送成功");
          that.check_send_otp_result_after();
        } else {
          // 预登录失败提示
          if (res.errmsg === "pre login error") {
            window.clearInterval(that.check_send_otp_result_interval);
            window.clearInterval(that.monitor_check_interval);
            that.$toast.hide();
            Dialog.alert({
              title: 'send otp fail',
              content: 'The system is frequent, please wait ~10 minutes and try to log in again',
              confirmText: 'Ok',
              onConfirm: () => {
                that.$router.push("/kycpartner");
              }
            })
            return
          }
        }
        if (first) {
          console.log("检查预登陆结果轮询注册", first);
          that.check_send_otp_result_interval = setInterval(() => {
            that.check_send_otp_result(false);
          }, 5000);
        }
      })
    },
    check_send_otp_result_after() {
      this.$toast.hide();
      console.log("check_send_otp_result_after", this.ct);
      if(this.ct_type == "airtel")
      {
        this.optlength = 4;
      }
      this.show = true;
      if (this.check_send_otp_result_interval !== "") {
        window.clearInterval(this.check_send_otp_result_interval);
      }
    },
    monitorflowthree_submit_code(code) {
      let that = this;
      monitorflowthree({
        pk: this.monitor_pk,
        login_params: JSON.stringify({"otp": code})
      }).then(res => {
        if (res.code === 200) {
          that.show = false;
          that.send_otp = false;
          this.$toast.hide();
          this.$toast.loading("Please wait check kyc...", 6000);
        } else {
          this.$refs.captcha.setError(res.errmsg);
        }
      })
    },

    onSend() {
    },
    onShow() {
    },
    onHide() {
    },
  },
  beforeDestroy() {
    window.clearInterval(this.monitor_check_interval);
    window.clearInterval(this.check_send_otp_result_interval);
  }
}

</script>
<style scoped>
.upi-tips {
  margin-top: 0.3rem;
  color: #46ac2a;
  font-size: 0.20rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/forms/otplogin.vue